// src/components/welcome/PartnersMarquee.jsx
import React, { useEffect } from "react";
import { Box, Stack, Typography, Chip, Avatar } from "@mui/material";
import { motion, useAnimation } from "framer-motion";
import tradingview from "./tradingview.png";
import securepay from "./securepay.png";
import chainlink from "./chainlink.png";
import binance from "./binance.png";
export default function PartnersMarquee({
  items,
  speed = 18,
  gap = 3,
  pauseOnHover = true,
  logoSize = 28,
}) {
  const partners =
    items && items.length
      ? items
      : [
          {
            name: "Binance",
            logo: binance,
            tagline: "Liquidity & Network Partner",
          },
          {
            name: "TradingView",
            // شعار واضح وملوّن رسمي من مصدر موثوق
            logo: tradingview,
            tagline: "Advanced Charting Tools",
          },
          {
            name: "SecurePay",
            // شعار حديث ومناسب بخلفية شفافة
            logo: securepay,
            tagline: "Payment Security Gateway",
          },
          {
            name: "Chainlink",
            logo: chainlink,
            tagline: "Blockchain Oracle Network",
          },
          {
            name: "MarketHub",
            logo: "https://cdn-icons-png.flaticon.com/512/1240/1240944.png",
            tagline: "Market Data Aggregation",
          },
        ];

  const loopItems = [...partners, ...partners];
  const controls = useAnimation();

  const startScroll = () => {
    controls.start({
      x: ["0%", "-50%"],
      transition: { repeat: Infinity, duration: speed, ease: "linear" },
    });
  };

  const stopScroll = () => controls.stop();

  useEffect(() => {
    startScroll();
  }, [speed, partners.length]);

  const borderColor = "rgba(255,255,255,0.08)";
  const surfaceColor = "#1C2526";
  const itemBg = "#242F31";
  const textColor = "#E0E0E0";
  const mask =
    "linear-gradient(to right, transparent, black 8%, black 92%, transparent)";

  return (
    <Box
      sx={{
        mt: 4,
        p: 2,
        borderRadius: 2,
        bgcolor: surfaceColor,
        border: `1px solid ${borderColor}`,
      }}
    >
      {/* Header */}
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, color: "#B0BEC5" }}
        >
          Strategic Integrations & Technology Partners
        </Typography>
        <Chip
          label="Trusted Ecosystem"
          size="small"
          sx={{
            bgcolor: "rgba(240,185,11,0.12)",
            color: "#F0B90B",
            border: "1px solid rgba(240,185,11,0.25)",
            fontWeight: 600,
          }}
        />
      </Stack>

      {/* Marquee */}
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          maskImage: mask,
          WebkitMaskImage: mask,
        }}
        onMouseEnter={() => pauseOnHover && stopScroll()}
        onMouseLeave={() => pauseOnHover && startScroll()}
      >
        <Box
          component={motion.div}
          animate={controls}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: gap,
            whiteSpace: "nowrap",
            willChange: "transform",
          }}
        >
          {loopItems.map((p, i) => (
            <Box
              key={`${p.name}-${i}`}
              sx={{
                px: 3,
                py: 1.2,
                border: `1px solid ${borderColor}`,
                borderRadius: 20,
                bgcolor: itemBg,
                display: "inline-flex",
                alignItems: "center",
                gap: 1.5,
                transition: "transform 0.25s ease, background 0.25s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  bgcolor: "#2E3A3C",
                },
              }}
            >
              <Avatar
                src={p.logo}
                alt={p.name}
                sx={{
                  width: logoSize,
                  height: logoSize,
                  bgcolor: "#FFFFFF",
                  p: 0.6,
                  border: "1px solid rgba(255,255,255,0.15)",
                  objectFit: "contain",
                }}
              />
              <Box
                sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: textColor,
                    fontSize: { xs: 13, sm: 14 },
                    letterSpacing: 0.3,
                  }}
                >
                  {p.name}
                </Typography>
                {p.tagline && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#9AA5AA",
                      fontSize: 11,
                      fontWeight: 500,
                    }}
                  >
                    {p.tagline}
                  </Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
